import React from 'react';
import SteamTagsSelector from '@intelligence/components/SteamTagsSelector';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getOptionLocaleText } from '../previewHelpers';
import { DEFAULT_SELECTOR_CONFIG, getGameEngineValue } from './utils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { IGameEngineFilterValue } from './types';

const GameEngineRenderer: React.FC<IFilterRenderProps<IGameEngineFilterValue>> = (props) => {
  const { field, AWidth: width = 440, value, onChange, selectorConfig, ...rest } = props;
  const engineValue = getGameEngineValue(value);

  return (
    // @ts-expect-error SteamTagsSelector 缺少完整 props 类型定义
    <SteamTagsSelector
      {...rest}
      showLogicSelector
      key={field}
      AWidth={width}
      selectorConfig={selectorConfig || DEFAULT_SELECTOR_CONFIG}
      filterLogic={engineValue.logic}
      value={engineValue.value}
      onConfirm={(payload?: string[], logic?: IRelation) => {
        onChange({
          logic: logic || engineValue.logic || 'OR',
          value: payload || [],
        });
      }}
      onLogicChange={(logic: IRelation) => {
        onChange({ logic, value: engineValue.value });
      }}
    />
  );
};

const GameEnginePreview: React.FC<{
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0];
  valueItem: any;
}> = (props) => {
  const { item, valueItem } = props;
  const { locale, formatMessage } = useIntlExtend();
  const { value: engineValue = [] } = valueItem || {};
  const options = item.controlProps?.options || [];
  const selectorLabel = item.controlProps?.selectorConfig?.label || 'dbi_top_game_engine';
  const label = item.label || selectorLabel;

  let content: React.ReactNode = formatMessage({ id: 'dbi_filterSave_none' });
  if (engineValue.length === 1) {
    const target = options.find((option: any) => option?.value === engineValue[0]);
    content = getOptionLocaleText(target, locale) || engineValue[0];
  } else if (engineValue.length > 1) {
    const allMatch =
      Array.isArray(options) &&
      options.length > 0 &&
      engineValue.length === options.length &&
      engineValue.every((v: string) => options.some((opt: any) => opt?.value === v));
    content = allMatch ? formatMessage({ id: 'dbi_all' }) : engineValue.length;
  }

  return (
    <>
      <span className="model-form-text">{formatMessage({ id: label })}</span>
      <span className="model-form-context">{content}</span>
    </>
  );
};

// eslint-disable-next-line react/display-name
function renderGameEnginePreview(
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0],
  value: any,
): React.ReactNode {
  return <GameEnginePreview item={item} valueItem={value} />;
}

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  return renderGameEnginePreview;
};

export const gameEngineControl: IFilterControlModule = {
  type: FILTER_TYPE.GAME_ENGINE,
  entry: {
    render: (props) => {
      return <GameEngineRenderer {...props} />;
    },
  },
  getRenderPreview,
};
